import { TournamentDetailsData } from 'config/types/tournament'
import React from 'react'
import { ModalColorTheme } from 'theme/modal/colors'
import AlchemyModal, { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import LeaderBoardFullTable from './LeaderBoardTable/FullTable'

const LeaderBoardModal: React.FC<ModalProps<{ tournamentDetails: TournamentDetailsData }>> = ({
  onDismiss,
  data: { tournamentDetails },
}) => {
  return (
    <AlchemyModal
      minWidth={['100%', '', '368px !important', '608px !important']}
      maxWidth={['100%', '', '368px !important', '608px !important']}
      minHeight="578px !important"
      onDismiss={onDismiss}
      colorTheme={ModalColorTheme.Darkblue}
    >
      <ModalHeader title="Leaderboard" colorTheme={ModalColorTheme.Darkblue} />

      <ModalBody width="100%" minHeight="463px">
        <LeaderBoardFullTable tournamentDetails={tournamentDetails} />
      </ModalBody>
    </AlchemyModal>
  )
}

export default LeaderBoardModal
